import { createSlice } from '@reduxjs/toolkit';

// DOMAIN
import { Domain } from 'constant';

// MODEL
import { OnBoardingState } from 'model';

// REDUCER ACTION
import {
  changeLoading,
  setLovedOne,
  setNric,
  setAccountStatus,
  setSuggestedRole,
  setVerified,
  setSessionId,
  setB3LookupResult,
  setMobileLast4,
  setLookupBlocked,
  setCompletedOnboard,
  setB3Snapshot,
  setB3HasActivePackage,
  setLinkpassPrefill,
  setLocalSessionId
} from './reducers';

export const initialState: OnBoardingState = {
  loading: false,
  lovedOne: '',
  nric: '',
  accountStatus: undefined,
  suggestedRole: undefined,
  isVerified: false,
  sessionId: undefined,
  b3LookupResult: undefined,
  mobileLast4: undefined,
  lookupBlocked: undefined,
  completedOnboard: undefined,
  b3Snapshot: undefined,
  b3HasActivePackage: undefined,
  linkpassPrefill: undefined,
  localSessionId: undefined
};

export const onBoardingSlice = createSlice({
  name: Domain.OnBoarding,
  initialState,
  reducers: {
    changeLoading,
    setLovedOne,
    setNric,
    setAccountStatus,
    setSuggestedRole,
    setVerified,
    setSessionId,
    setB3LookupResult,
    setMobileLast4,
    setLookupBlocked,
    setCompletedOnboard,
    setB3Snapshot,
    setB3HasActivePackage,
    setLinkpassPrefill,
    setLocalSessionId,
    reset: () => initialState
  }
});

export default onBoardingSlice.reducer;
